
  import { Component, Prop, Watch } from 'vue-property-decorator'
  import { BaseChart } from '@/components/dashboards/baseChart'
  import { channelColors } from '@/utils/channelColors'

@Component({})
  export default class CreditsByChannelPie extends BaseChart {
  @Prop() credits: Record<string, any>
  channelColors = channelColors
  channels = []

  // Methods
  getExecutivesByChannel (channel) {
    const credits = this.credits?.loans_evaluation_view_aggregate?.nodes
    const byChannel = credits.filter(purchase => purchase.channel.name === channel)

    let executives = []
    byChannel.forEach(credit => {
      const creditExecutive = credit.executive?.person
      if (creditExecutive && !executives.map(executive => executive?.id).includes(creditExecutive?.id)) {
        executives.push(creditExecutive)
      }
    })
    executives = executives.filter(executive => executive)

    const returnArray = executives.map(executive => {
      return {
        name: `${executive.first_name} ${executive.surname}`,
        leads: byChannel.filter(credit => credit.executive.person.id === executive.id),
      }
    })

    const noExecutive = byChannel.filter(credit => !credit.executive)
    if (noExecutive.length > 0) {
      returnArray.push({
        name: 'SIN EJECUTIVO',
        leads: noExecutive,
      })
    }

    return returnArray
  }

  getCountByChannel (channel) {
    if (!this.credits?.loans_evaluation_view_aggregate?.nodes) return
    const filteredByChannel = this.credits?.loans_evaluation_view_aggregate?.nodes.filter(node => {
      return node.channel.name === channel
    })
    return filteredByChannel.length
  }

  getStock () {
    if (!this.credits) return
    const credits = this.credits?.loans_evaluation_view_aggregate?.nodes
    if (!credits) return

    let channels = []
    credits.forEach(sale => {
      const channel = sale.channel
      if (!channels.map(channel => channel.name).includes(channel.name)) {
        channels.push(channel)
      }
    })
    channels = channels.sort((prev, next) => {
      return this.getCountByChannel(next.name) - this.getCountByChannel(prev.name)
    })
    this.channels = channels

    this.series = channels.map(channel => {
      const filteredByChannel = credits.filter(sale => sale.channel?.name === channel.name)
      return filteredByChannel.length
    })

    const colors = channels.map(channel => {
      return channelColors[channel.name]
    })

    this.chartOptions = {
      labels: channels.map(channel => channel.description),
      colors,
      legend: {
        show: false,
        position: 'bottom',
        horizontalAlign: 'center',
      },
      // dataLabels: {
      //   formatter: val => Math.round((val * this.creditsNumber) / 100),
      // },
      plotOptions: {
        pie: {
          dataLabels: {
            minAngleToShowLabel: 1,
          },
        },
      },
    }
  }

  // Getters
  get creditsNumber () {
    if (!this.credits?.loans_evaluation_view_aggregate?.nodes) return
    return this.credits?.loans_evaluation_view_aggregate?.nodes.length
  }

  // Watchers
  @Watch('credits', { immediate: true, deep: true })
  onDatesChange () {
    this.display = false
    this.getStock()
    this.display = true
  }
  }
